import Behaviour from "../../lib/ui/Behaviour";
import UtilityLayer from "./devutilitylayer/UtilityLayer";
export default class MapUtilityBehaviour extends Behaviour {
    constructor(app) {
        super();
        this.app = app;
        this.layer = null;
    }
    begin() {
        this.layer = new UtilityLayer();
        this.app.map.addGameLayer(this.layer);
    }
    end() {
        this.layer.remove();
        this.layer.clearLayers();
    }
}
